(function () {
  if (window.SKBKlaviyoSignupInit) {
    window.SKBKlaviyoSignupInit();
    return;
  }

  const RECAPTCHA_SCRIPT_ID = 'skb-google-recaptcha-api';

  function loadRecaptcha(callback) {
    if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
      callback();
      return;
    }

    document.addEventListener('skb:recaptcha-ready', callback, { once: true });

    if (document.getElementById(RECAPTCHA_SCRIPT_ID)) {
      return;
    }

    window.skbKlaviyoRecaptchaReady = function () {
      document.dispatchEvent(new Event('skb:recaptcha-ready'));
    };

    const script = document.createElement('script');
    script.id = RECAPTCHA_SCRIPT_ID;
    script.src = 'https://www.google.com/recaptcha/api.js?onload=skbKlaviyoRecaptchaReady&render=explicit';
    script.async = true;
    script.defer = true;

    document.head.appendChild(script);
  }

  function setMessage(message, text) {
    if (message) {
      message.textContent = text;
    }
  }

  function getFormFields(form) {
    const formData = new FormData(form);
    const fields = {};

    formData.forEach(function (value, key) {
      if (!key) {
        return;
      }

      const cleanValue = String(value).trim();

      if (!cleanValue) {
        return;
      }

      if (fields[key]) {
        if (!Array.isArray(fields[key])) {
          fields[key] = [fields[key]];
        }

        fields[key].push(cleanValue);
      } else {
        fields[key] = cleanValue;
      }
    });

    return fields;
  }

  function getProfileFields(fields) {
    const profile = {};
    const location = {};
    const properties = {};

    const profileKeys = [
      'email',
      'phone_number',
      'first_name',
      'last_name',
      'organization',
      'title'
    ];

    const locationKeys = [
      'address1',
      'address2',
      'city',
      'region',
      'zip',
      'country',
      'timezone'
    ];

    Object.keys(fields).forEach(function (key) {
      if (profileKeys.indexOf(key) !== -1) {
        profile[key] = fields[key];
        return;
      }

      if (locationKeys.indexOf(key) !== -1) {
        location[key] = fields[key];
        return;
      }

      properties[key] = fields[key];
    });

    if (Object.keys(location).length) {
      profile.location = location;
    }

    if (Object.keys(properties).length) {
      profile.properties = properties;
    }

    return profile;
  }

  function resetCaptcha(form, submitButton) {
    const widgetId = form.dataset.recaptchaWidgetId;

    if (window.grecaptcha && typeof widgetId !== 'undefined') {
      window.grecaptcha.reset(Number(widgetId));
    }

    form.dataset.captchaReady = 'false';
    submitButton.disabled = true;
  }

  function initForm(form) {
    if (form.dataset.skbBound === 'true') {
      return;
    }

    form.dataset.skbBound = 'true';
    form.dataset.captchaReady = 'false';

    const submitButton = form.querySelector('button[type="submit"]');
    const captchaContainer = form.querySelector('[data-skb-recaptcha]');
    const message = form.querySelector('[data-skb-message], .klaviyo-signup-message');

    if (!submitButton || !captchaContainer) {
      return;
    }

    submitButton.disabled = true;

    loadRecaptcha(function () {
      if (captchaContainer.dataset.rendered === 'true') {
        return;
      }

      const sitekey = captchaContainer.dataset.sitekey;

      if (!sitekey) {
        setMessage(message, 'Captcha site key is missing.');
        return;
      }

      const widgetId = window.grecaptcha.render(captchaContainer, {
        sitekey: sitekey,
        callback: function () {
          form.dataset.captchaReady = 'true';
          submitButton.disabled = false;
          setMessage(message, '');
        },
        'expired-callback': function () {
          form.dataset.captchaReady = 'false';
          submitButton.disabled = true;
          setMessage(message, 'Please complete the captcha.');
        },
        'error-callback': function () {
          form.dataset.captchaReady = 'false';
          submitButton.disabled = true;
          setMessage(message, 'Captcha could not load. Please try again.');
        }
      });

      form.dataset.recaptchaWidgetId = String(widgetId);
      captchaContainer.dataset.rendered = 'true';
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const endpoint = form.dataset.endpoint;
      const listId = form.dataset.listId;
      const source = form.dataset.source || '';
      const formId = form.dataset.formId || '';
      const fields = getFormFields(form);
      const profile = getProfileFields(fields);
      const email = fields.email || '';

      if (!endpoint) {
        setMessage(message, 'Signup endpoint is missing.');
        return;
      }

      if (!listId) {
        setMessage(message, 'Klaviyo list ID is missing.');
        return;
      }

      if (!email) {
        setMessage(message, 'Please enter your email address.');
        return;
      }

      if (
        form.dataset.captchaReady !== 'true' ||
        typeof window.grecaptcha === 'undefined' ||
        typeof form.dataset.recaptchaWidgetId === 'undefined'
      ) {
        setMessage(message, 'Please complete the captcha.');
        submitButton.disabled = true;
        return;
      }

      const recaptchaToken = window.grecaptcha.getResponse(Number(form.dataset.recaptchaWidgetId));

      if (!recaptchaToken) {
        setMessage(message, 'Please complete the captcha.');
        form.dataset.captchaReady = 'false';
        submitButton.disabled = true;
        return;
      }

      setMessage(message, 'Submitting...');
      submitButton.disabled = true;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: email,
            recaptcha_token: recaptchaToken,
            list_id: listId,
            source: source,
            form_id: formId,
            fields: fields,
            profile: profile
          })
        });

        let result = {};

        try {
          result = await response.json();
        } catch (error) {
          result = {};
        }

        if (response.ok && result.success) {
          setMessage(message, result.message || 'Thanks, you are signed up.');
          form.reset();
          form.classList.add('skb-success'); // lets CSS hide the fields and enlarge the message
        } else {
          setMessage(message, result.message || 'Something went wrong. Please try again.');
        }

        resetCaptcha(form, submitButton);
      } catch (error) {
        setMessage(message, 'Something went wrong. Please try again.');
        resetCaptcha(form, submitButton);
      }
    });
  }

  function initForms() {
    const forms = document.querySelectorAll('[data-skb-klaviyo-form]');

    forms.forEach(function (form) {
      initForm(form);
    });
  }

  window.SKBKlaviyoSignupInit = initForms;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }
})();